import { useMutation } from "@tanstack/react-query";

import {
  PaymentPollingStatus,
  PaymentPollingStatusType,
  ICheckPaymentStatusResponse, PaymentDestinationType,
} from "../types.ts";
import { delay } from "../../../utils";
import { paymentsAPI } from "../paymentsAPI.ts";

const POLL_INTERVAL_MS = 1000; // 1сек
const MAX_TOTAL_TIME_MS = 6000; // 6сек

export const useMakePaymentMutation = () => {
  return useMutation ({
    mutationKey: ["make-payment"],
    mutationFn: async (
      {
        productId,
        amount,
        paymentDestination,
      }: {
        productId: string;
        amount: string;
        paymentDestination?: PaymentDestinationType;
      }) => {
      const paymentResponse = await paymentsAPI.makePayment({ productId, amount, paymentDestination });
      if (paymentResponse.statusCode === "DONE" || paymentResponse.statusCode === "ERROR") {
        return paymentResponse;
      }

      if (paymentResponse.statusCode !== "IN_PROGRESS") {
        throw new Error(`Unexpected status while make a payment: ${paymentResponse.statusCode}`);
      }

      const applicationId = paymentResponse.id;
      if (!applicationId) {
        throw new Error("Application ID is undefined");
      }

      const pollingStartTime = Date.now();

      let pollingResponse = paymentResponse as ICheckPaymentStatusResponse;
      while (pollingResponse.statusCode === "IN_PROGRESS") {
        const timePassed = Date.now() - pollingStartTime;

        if (timePassed > MAX_TOTAL_TIME_MS) {
          return pollingResponse;
        }

        await delay(POLL_INTERVAL_MS);
        pollingResponse = await paymentsAPI.checkPaymentStatus(applicationId);
      }

      if (!PaymentPollingStatus.includes(pollingResponse.statusCode as PaymentPollingStatusType)) {
        throw new Error(`Unexpected status after pooling a payment result: ${pollingResponse.statusCode}`);
      }

      return pollingResponse;
    },
  });
};
